// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      display: 'grid',
      justifyContent: 'center',
      alignItems: 'center',

      '& .hexColorPicker': {
        width: 'fit-content',
        margin: '0.75em auto',
      },
      '& .condensed-line': {
        textAlign: 'center',
        display: 'block',
        fontSize: 44,
        lineHeight: '32px',
        fontStretch: 'ultra-condensed',
      },
      '& .colorHex': {
        cursor: 'pointer',
        position: 'relative',
      },
      '& .ornamentSvg': {
        right: 12,
        bottom: 20,
        position: 'absolute',
      },
    },
  }),
);

export default useStyles;
